import { GetListParams } from 'react-admin';
import {
  CustomDataProvider,
  registerModuleDataProvider,
} from '../../../providers/CustomDataProvider';
import {
  SweepWalletFilters,
  listSweepWallets,
} from '../../../services/xbitRelaySweepService';

const resourceName = 'xbit-relay/sweep-monitor';

const pickFilter = (filter: any): SweepWalletFilters => {
  if (!filter) return {};
  const out: SweepWalletFilters = {};
  if (filter.userId) out.userId = filter.userId;
  if (filter.provider) out.provider = filter.provider;
  if (filter.address) out.address = filter.address;
  if (filter.chainId !== undefined && filter.chainId !== '' && filter.chainId !== null) {
    out.chainId = Number(filter.chainId);
  }
  if (filter.hideZeroBalance) out.hideZeroBalance = true;
  return out;
};

const pickSort = (
  sort: any,
): Pick<SweepWalletFilters, 'orderBy' | 'orderDirection'> => {
  const field = sort?.field === 'balance' ? 'balance' : 'lastActive';
  const orderDirection = sort?.order === 'ASC' ? 'ASC' : 'DESC';
  return { orderBy: field, orderDirection };
};

export const xbitRelaySweepMonitorDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};

    const response = await listSweepWallets({
      ...pickFilter(filter),
      ...pickSort(params.sort),
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({
        ...item,
        id: `${item.address}:${item.chainId}:${item.token}`,
      })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelaySweepMonitorDataProvider);
